import { useState } from 'react'
import BrandLogo from './BrandLogo'

interface AppHeaderProps {
  /** Show tagline below LoanLoop */
  showTagline?: boolean
  /** Right side content (nav links, user menu, etc.) */
  rightContent?: React.ReactNode
  /** Nav bar style - affects background */
  variant?: 'default' | 'landing'
  className?: string
}

export default function AppHeader({
  showTagline = false,
  rightContent,
  variant = 'default',
  className = '',
}: AppHeaderProps) {
  const [mobileOpen, setMobileOpen] = useState(false)

  const navClass =
    variant === 'landing'
      ? 'bg-white/80 backdrop-blur-sm shadow-sm sticky top-0 z-50'
      : 'bg-white shadow-sm'

  return (
    <nav className={`${navClass} ${className}`}>
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="flex justify-between items-center h-16">
          <BrandLogo showTagline={showTagline} size="md" linkToHome />

          {/* Desktop nav */}
          {rightContent && (
            <div className="hidden sm:flex items-center gap-4">{rightContent}</div>
          )}

          {/* Mobile hamburger button */}
          {rightContent && (
            <button
              className="sm:hidden p-2 rounded-md text-gray-600 hover:text-primary-600 hover:bg-gray-100 transition-colors"
              onClick={() => setMobileOpen(!mobileOpen)}
              aria-label="Toggle menu"
            >
              {mobileOpen ? (
                <svg className="w-6 h-6" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M6 18L18 6M6 6l12 12" />
                </svg>
              ) : (
                <svg className="w-6 h-6" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M4 6h16M4 12h16M4 18h16" />
                </svg>
              )}
            </button>
          )}
        </div>
      </div>

      {/* Mobile dropdown menu */}
      {mobileOpen && rightContent && (
        <div className="sm:hidden bg-white border-t border-gray-100 px-4 py-4 flex flex-col gap-4 shadow-md">
          {rightContent}
        </div>
      )}
    </nav>
  )
}
